'use client';
import React from 'react';

const principles = [
  'Weight is feedback.',
  'Compliance is the scoreboard.',
  'Execution beats motivation.',
  'The trend tells the truth.',
  'No second bad day.',
  'Log it before you negotiate with it.',
  'The forge reveals the truth.',
  'Built daily. Forged over time.',
];

export default function PrinciplesTicker() {
  const doubled = [...principles, ...principles];

  return (
    <div className="w-full border-b border-border bg-card overflow-hidden py-2.5">
      <div className="flex animate-ticker whitespace-nowrap" style={{ width: 'max-content' }}>
        {doubled?.map((p, i) => (
          <span key={`ticker-${i}`} className="inline-flex items-center gap-6 px-6 text-2xs font-bold tracking-[0.15em] text-muted-foreground uppercase">
            <span className="w-1 h-1 rounded-full bg-primary inline-block" />
            {p}
          </span>
        ))}
      </div>
    </div>
  );
}